/* eslint-disable no-undef */
import React, { useEffect, useState, useRef } from "react";
import { postNumbaKakaoLogin, postInsFcmToken } from "../../api/auth";
import { toast } from "wc-toast";
import { useAtom } from "jotai";
import { jwtDecode } from "jwt-decode";
import { userLoginJotai } from "../../App";
import { useNavigate } from "react-router-dom";
import { HashLoader } from "react-spinners";
import { isAndroidApp, isIOSApp, isMobileWeb, detectPlatform } from "../../utils/hooks/app-communication/webToApp/getFcm";
import { messagingReady } from "../../firebase";
import { getToken } from "firebase/messaging";

export default function OAuthPage() {
  const [userLoginAtom, setUserLoginAtom] = useAtom(userLoginJotai);
  const navigate = useNavigate();
  const fcmFlagRef = useRef('');
  const regObj = JSON.parse(sessionStorage.getItem('regObj'));

  const handleFCMToken = async (token) => {
    if (token) {
      await postInsFcmToken({ fcm_token: token, fcm_flag: fcmFlagRef.current })
        .then((res) => {
          console.log('fcmToken success', res?.message);
        })
        .catch((err) => {
          console.error('fcmToken fail >>>', err);
        });
    } else {
      console.log('fcmToken is invalid');
    }
  };

  // 전역 함수로 선언 (iOS/Android 네이티브에서 호출)
  window.handleFCMToken = handleFCMToken;

  const processKAKAOSignUp = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const code = urlSearchParams.get("code");

    const ADS_YN = regObj?.ads_yn ?? "";
    const PATH_CD = regObj?.reg_path_cd ?? "";
    fcmFlagRef.current = '';

    try {
      const response = await postNumbaKakaoLogin({
        code: code,
        ads_yn: ADS_YN,
        reg_path_cd: PATH_CD,
      });

      if (response?.code === 1000) {
        setUserLoginAtom(response);
        setTimeout(() => console.log("인증완료"), 100);

        localStorage.setItem("access_token", response?.access_token);
        localStorage.setItem("refresh_token", response?.refresh_token);
        localStorage.setItem("device_id", response?.device_id);

        // fcmToken 호출
        if (isAndroidApp()) {
          console.log('Android TOPTOP_APP Call');
          fcmFlagRef.current = 'a';
          window.TOPTOP_APP.getFCMToken("handleFCMToken");

        } else if (isIOSApp()) {
          console.log('IOS App');
          fcmFlagRef.current = 'i';
          window.webkit.messageHandlers.getFCMToken.postMessage("handleFCMToken");

        } else if (isMobileWeb()) {
          fcmFlagRef.current = detectPlatform();
          const permission = await Notification.requestPermission();
          if (permission !== "granted") return;

          if ("serviceWorker" in navigator) {
            const msg = await messagingReady;

            if (msg) {
              const token = await getToken(msg, {
                vapidKey: process.env.REACT_APP_VAPID_PUBLIC_KEY,
                serviceWorkerRegistration:
                  await navigator?.serviceWorker?.register(
                    "/firebase-messaging-sw.js"
                  ),
              });
              await handleFCMToken(token);
            } else {
              console.log("Firebase Messaging 미지원 환경 - FCM 토큰 생략");
            }

          } else {
            toast.error('앱푸시 지원하지 않음');
            console.log("Service Worker not supported");
          }
        }

        // 가입/로그인 후 이동
        sessionStorage.removeItem('regObj');
        navigate("/");

      } else if (response?.code === -21) {
        toast.error("아이디가 중지 또는 휴먼상태 입니다.");
      } else if (response?.code === -25) {
        toast.error("일반회원 가입자이므로 일반회원으로 로그인 해 주세요.");
      } else if (response?.code === -28) {
        toast.error("카카오 로그인에서 전화번호를 제공받을 수 없습니다. 일반회원으로 가입해주세요");
      } else {
        if (response?.user_state_val === "withdraw") {
          toast.error("회원 탈퇴 시 하루 뒤에 가입이 가능합니다.");
        }
        setTimeout(() => navigate("/login"), 1000);
      }

    } catch (err) {
      console.log("err", err);
      if (err.code === -21) {
        toast.error("아이디가 중지 또는 휴먼상태 입니다.");
        navigate("/login");
      } else if (err.code === -25) {
        toast.error("일반회원 가입자이므로 일반회원으로 로그인 해주세요.");
        navigate("/login");
      } else if (err.code === -28) {
        toast.error("카카오 로그인에서 전화번호를 제공받을 수 없습니다. 일반회원으로 가입해주세요");
        navigate("/RegularUser");
      } else if (err.code === -9) {
        toast.error("카카오 계정 회원가입이 되어있지 않습니다. 회원가입을 해주세요.");
        navigate("/RegularUser");
      } else {
        setTimeout(() => navigate("/login"), 1000);
      }
    } finally {
      sessionStorage.removeItem('regObj');
    }
  };

  useEffect(() => {
    processKAKAOSignUp();
  }, []);

  return (
    <div className="d-flex justify-content-center align-items-center h-500">
      <HashLoader
        loading={true}
        color="#FFDD00"
        size={150}
      />
    </div>
  );
}
